import Vue from 'vue'
import Vuex from 'vuex'
import sidebar from './modules/sidebar'
import config from './modules/config'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    config,
    sidebar,
  },
})
